module.exports = __webpack_public_path__ + "assets/img/ecosystem.ccedf178.png";